<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('CustomerList.customerList')"/>
        </div>
    </div>
</template>

<script>
import PageTitle from "../../shared/misc/PageTitle";
export default {
    name: "CustomerList",
    components: {PageTitle},
    props: {
        customers: {
            required: true,
        },
    },
    watch: {
        $allCustomersSelected(value) {
            if (value === false) {
                return this.$router.push("/crm/customer");
            }
        },
    },
};
</script>

<style scoped>

</style>